export default "__VITE_ASSET__BUF3x8UR__"